import {
  FC, useMemo, useCallback,
} from 'react';

import { useTranslation } from 'next-i18next';
import Icon from 'src/common/components/IconDS22';
import { useRequestInfoContext } from 'src/common/providers/RequestInfoProvider';
import getClassNames from 'src/common/utils/getClassNames';
import classNames from 'classnames';
import { ENABLED_LOCALES } from 'src/common/constants';
import styles from './LanguageSelector.module.scss';

type LanguageSelectorProps = {
  onChange: (languageCode: string) => void;
  fullWidth?: boolean;
};

const LanguageSelector: FC<LanguageSelectorProps> = ({ onChange, fullWidth = false }) => {
  const { i18n } = useTranslation();
  const requestContext = useRequestInfoContext();

  const language = i18n.language ?? requestContext.locale;

  const renderOption = useCallback((locale: string) => (
    <option
      key={locale}
      value={locale}
      disabled={locale === language}
    >
      {locale.toUpperCase()}
    </option>
  ), [language]);

  const options = useMemo(
    () => ENABLED_LOCALES?.map(renderOption),
    [renderOption],
  );

  if (!language) {
    return null;
  }

  return (
    <label
      htmlFor="language"
      className={styles.trigger}
    >
      <Icon
        id="translate"
        size="m"
        className={styles.icon}
      />
      <select
        id="language"
        className={getClassNames(styles, 'select', classNames({ fullWidth }))}
        value={language}
        onChange={(event) => onChange(event.target.value)}
      >
        {options}
      </select>
    </label>
  );
};

export default LanguageSelector;
